module.exports = __webpack_public_path__ + "static/media/confirmbeep.9e08c7f4.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/confirmbeep.wav
// module id = 2831
// module chunks = 0